import { safeParseNullDefault, safeParse } from 'shouldve-been-js';

class Department {

    private _departmentId: string;
    private _name: string;
    private _status: string;

    public constructor(departmentId: string, name: string, status: string) {

        this._departmentId = departmentId;
        this._name = name;
        this._status = status;
    }

    public get departmentId(): string {
        return this._departmentId;
    }

    public set departmentId(value: string) {
        this._departmentId = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get status(): string {
        return this._status;
    }

    public set status(value: string) {
        this._status = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): Department | null {

        const departmentId: string | null = safeParseNullDefault<string>(json?.departmentId, '');
        const name: string = safeParse<string>(json?.name, '');
        const status: string = safeParse<string>(json?.status, '');
        
        if (departmentId === null || departmentId === '') {
            return null;
        }

        return new Department(departmentId, name, status);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): Department | null {

        const departmentId: string | null = safeParseNullDefault<string>(object?._departmentId, '');
        const name: string = safeParse<string>(object?._name, '');
        const status: string = safeParse<string>(object?._status, '');
        
        if (departmentId === null || departmentId === '') {
            return null;
        }

        return new Department(departmentId, name, status);
    }
}

export default Department;